const Http = new XMLHttpRequest();
const url = "/xtheme/basket_partial";
Http.open("GET", url);
Http.send();
Http.onreadystatechange=(function(){
    document.getElementById("mobile-navigation-basket-partial").innerHTML = Http.responseText;
    document.getElementById("navigation-basket-partial").innerHTML = Http.responseText;
});

// START IMAGE LAZY LOAD
const lazyImages = document.querySelectorAll('[lazy]');
const lazyImagesObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
        // image is onscreen
        if (entry.isIntersecting) {
            const lazyImage = entry.target;
            const src = lazyImage.dataset.src;
            if (lazyImage.tagName.toLowerCase() === 'img') {
                lazyImage.src = src;
            } else {
                // set background image
                lazyImage.style.backgroundImage = "url(\'" + src + "\')";
            }
            // remove lazy attribute
            lazyImage.removeAttribute('lazy');
            // job done, donot need to observe
            observer.unobserve(lazyImage);
        }
    });
});
lazyImages.forEach((lazyImage) => {
    lazyImagesObserver.observe(lazyImage);
});
// END IMAGE LAZY LOAD

var infinite = new Waypoint.Infinite({
    element: $('.infinite-container')[0],
    handler: function(direction) {

    },
    offset: 'bottom-in-view',

    onBeforePageLoad: function () {

    },

    onAfterPageLoad: function () {
        // observe objects for lazy images
        document.querySelectorAll('[lazy]').forEach((lazyImage) => {
            lazyImagesObserver.observe(lazyImage);
        });
    }

});

function showPreview(productId) {
    var modal_select = "#product-" + productId + "-modal";
    var product_modal = $(modal_select);
    if (product_modal.length) {
        product_modal.modal("show");
        return;
    }

    // make sure modals disappear and are not "cached"
    $(document).on('hidden.bs.modal', modal_select, function(){
        $(modal_select).remove();
    });

    $.ajax({
        url: "/xtheme/product_preview",
        method: "GET",
        data: {
            id: productId
        },
        success: function(data) {
            $("body").append(data);
            $(modal_select).modal("show");
            updatePrice();
            $(".selectpicker").selectpicker();
        }
    });
}

function setProductListViewMode(isInListMode) {
    if (typeof(Storage) !== "undefined") {
        localStorage.setItem("product_list_view_list_mode", (isInListMode ? "list" : "grid"));
    }
}

function getProductListViewMode() {
    if (typeof(Storage) !== "undefined") {
        return localStorage.getItem("product_list_view_list_mode");
    }
    return "grid";
}

function moveToPage(pageNumber) {
    var pagination = $("ul.pagination");
    // Prevent double clicking when ajax is loading
    if (pagination.prop("disabled")) {
        return false;
    }
    pagination.prop("disabled", true);

    if (typeof(pageNumber) !== "number") {
        pageNumber = parseInt(pageNumber);
        if (isNaN(pageNumber)) {
            return;
        }
    }
    window.PAGE_NUMBER = pageNumber;

    reloadProducts();
}

function reloadProducts() {
    var filterString = "?sort=" + $("#id_sort").val() + "&page=" + window.PAGE_NUMBER;
    $("#ajax_content").load(location.pathname + filterString);
}

function updatePrice() {
    var $quantity = $("#product-quantity");
    if ($quantity.length === 0 || !$quantity.is(":valid")) {
        return;
    }

    var data = {
        id: $("input[name=product_id]").val(),
        quantity: $quantity.val()
    };
    var $simpleVariationSelect = $("#product-variations");
    if ($simpleVariationSelect.length > 0) {
        // Smells like a simple variation; use the selected child's ID instead.
        data.id = $simpleVariationSelect.val();
    } else {
        // See if we have variable variation select boxes; if we do, add those.
        $("select.variable-variation").serializeArray().forEach(function(obj) {
            data[obj.name] = obj.value;
        });
    }
    jQuery.ajax({url: "/xtheme/product_price", dataType: "html", data: data}).done(function(responseText) {
        var $content = jQuery("<div>").append(jQuery.parseHTML(responseText)).find("#product-price-div");
        jQuery("#product-price-div").replaceWith($content);
        if($content.find("#no-price").length > 0)
        {
            $("#add-to-cart-button").prop("disabled", true);
        }
        else
        {
            $("#add-to-cart-button").not(".not-orderable").prop("disabled", false);
        }
    });
}

$(function() {
    $("#search-modal").on("show.bs.modal", function() {
        setTimeout(function(){
            $("#site-search").focus();
        }, 300)
    });

    function openMobileNav() {
        $(document.body).addClass("menu-open");
    }

    function closeMobileNav() {
        $(document.body).removeClass("menu-open");
    }

    function MobileNavIsOpen() {
        return $(document.body).hasClass("menu-open");
    }

    $(".toggle-mobile-nav").click(function(e) {
        e.stopPropagation();
        if (MobileNavIsOpen()) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    });

    $(document).click(function(e) {
        if (MobileNavIsOpen() && !$(e.target).closest(".pages .nav-collapse").length) {
            closeMobileNav();
        }

    });

    $(".main-nav .dropdown-menu").click(function(e) {
        e.stopPropagation();
    });

    $("#product-list-view-type").on("change", function() {
        var $productListView = $(".product-list-view");
        $productListView.toggleClass("list");
        setProductListViewMode($productListView.hasClass("list"));
    })

    $(".selectpicker").selectpicker();

    // By default product list view is in grid mode
    var $productListView = $(".product-list-view");
    if ($productListView.length > 0 && getProductListViewMode() == "list") {
        $productListView.addClass("list");
        $("#product-list-view-type").prop('checked', true);
    }

    // Add proper classes to category navigation based on current-page class
    var $currentlySelectedPage = $(".current-page");
    if ($currentlySelectedPage.length > 0) {
        $currentlySelectedPage.addClass("current");
        $currentlySelectedPage.parents("li").addClass("current");
    }

    $(document).on("change", ".variable-variation, #product-variations, #product-quantity", updatePrice);
    updatePrice();
});

jQuery(document).ready(function() {
    $("#navbar").affix({offset: {top: $(".header").outerHeight(true)} });

    $().UItoTop({easingType: 'easeOutQuart'});

    $('.js-newsletter-toggle').on('click', function() {
        $('.newsletter').toggleClass('is-up');
        if (typeof(localStorage) !== "undefined" && localStorage !== null) {
            localStorage.hideNewsletter = $('.newsletter').hasClass('is-up') ? false : true;
        }
    });
    if (typeof(localStorage) !== "undefined" && localStorage !== null) {
        if (typeof localStorage.hideNewsletter === 'undefined' || localStorage.hideNewsletter === 'false') {
            $('.js-newsletter-toggle').trigger('click');
        }
    }

    // Create a new instance of Slidebars
    var controller = new slidebars();

    // Initialize Slidebars
    controller.init();

    // Left Slidebar controls
    $('.navbar-toggle').on('click', function (event) {
        event.stopPropagation();
        controller.toggle('slidebar');
        $(this).toggleClass('active');
    });

    // Close any Sidebar
    $(controller.events).on('opened', function () {
        $('[canvas="container"]').addClass('js-close-any-slidebar');
    });

    $(controller.events).on('closed', function () {
        $('[canvas="container"]').removeClass('js-close-any-slidebar');
    });

    $('body').on('click', '.js-close-any-slidebar', function (event) {
        event.stopPropagation();
        controller.close();
    });

// BEGIN: shoop/themes/modern_gray/templates/modern_gray/shoop/front/product/detail.jinja
    // Set up owl carousel for product page's slider thumbnails.
    $(".owl-carousel.carousel-thumbnails").owlCarousel({
        margin: 10,
        nav: $(".carousel-thumbnails .thumbnail").length > 4,
        navText: [
            "<i class='fa fa-chevron-left'></i>",
            "<i class='fa fa-chevron-right'></i>"
        ],
        responsiveClass: true,
        items: 4
    });

    // Enable lightbox for products with multiple images. Uses arrows to
    // navigate through images.
    var selector_multiple = "a[data-imagelightbox='image-multiple']";
    var instance_multiple = $(selector_multiple).imageLightbox({
        "onStart": function() {
            overlayOn();
            closeButtonOn(instance_multiple);
            arrowsOn(instance_multiple, selector_multiple);
        },
        "onEnd": function() {
            overlayOff();
            closeButtonOff();
            arrowsOff();
            captionOff();
        },
        "onLoadStart": function() {
            activityIndicatorOn();
            captionOff();
        },
        "onLoadEnd": function() {
            $(".imagelightbox-arrow").css("display", "block");
            activityIndicatorOff();
            captionOn();
        }
    });

    // Enable lightbox for products with only one image.
    var selector = "a[data-imagelightbox='image']";
    var instance = $(selector).imageLightbox({
        "onStart": function() {
            overlayOn();
            closeButtonOn(instance);
        },
        "onEnd": function() {
            overlayOff();
            closeButtonOff();
            captionOff();
        },
        "onLoadStart": function() {
            activityIndicatorOn();
            captionOff();
        },
        "onLoadEnd": function() {
            $(".imagelightbox-arrow").css("display", "block");
            activityIndicatorOff();
            captionOn();
        }
    });
// END: shoop/themes/modern_gray/templates/modern_gray/shoop/front/product/detail.jinja

// BEGIN: shoop/themes/modern_gray/templates/modern_gray/add_product_to_basket.jinja
    $("form.add-to-basket").on("submit", function(e) {
        e.preventDefault();
        addToBasket($(this));
    });
// END: shoop/themes/modern_gray/templates/modern_gray/add_product_to_basket.jinja

// BEGIN shoop/themes/modern_gray/templates/modern_gray/shoop/front/includes/_modal.jinja
    var expired = !isNaN(parseInt(localStorage["PopupShown"])) ? parseInt(localStorage["PopupShown"]) : new Date(0);
    if(Date.now() > expired) {
        $("#global-modal").modal({show: true, backdrop: true});
        var date = new Date();
        date.setHours(date.getHours() + 12);
        localStorage["PopupShown"] = date.getTime();
    }
// END shoop/themes/modern_gray/templates/modern_gray/shoop/front/includes/_modal.jinja

    // submit sort feature in product list and category
    $("#sorter :input").change(function() {
        $("#sorter").submit();
    });

    $("#modal-toc a").click(function() {
        $("#modal-toc").modal("hide");
    });

    $('.owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {items: 3},
            600: {items: 5},
            1000: {items: 6},
        },
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
    });
});